//Auth
export const SAVE_TOKEN = "SAVE_TOKEN";
export const SAVE_USER = "SAVE_USER";
export const DELETE_TOKEN = "DELETE_TOKEN";
//Config
export const SET_LANGUAGE = "SET_LANGUAGE";
//Designer
export const SET_DESIGNER_MODEL = "SET_DESIGNER_MODEL"
export const SET_LIST_POINT_OF_SALES = "SET_LIST_POINT_OF_SALES"
export const DELETE_LIST_POINT_OF_SALES = "DELETE_LIST_POINT_OF_SALES"
